module.exports = __webpack_public_path__ + "assets/img/img181.b37b5a78.png";